import { useEffect, useRef } from "react";
import { useConsent } from "../consent/useConsent";
import { initGA, revokeGA } from "./ga";

/**
 * AnalyticsLoader – bezskriptový komponent, ktorý sleduje zmeny súhlasu
 * a podľa toho inicializuje alebo deaktivuje GA4.
 *
 * Umiestni ho raz do stromu komponentov vnútri <ConsentProvider>.
 * Nerenderuje žiadne UI.
 *
 * Príklad: <AnalyticsLoader /> v App.js
 */
function AnalyticsLoader() {
  const { consent } = useConsent();
  const prevAnalytics = useRef(null);

  useEffect(() => {
    if (!consent) return;

    const hasAnalytics = consent.analytics;

    // Zabráni opakovanému volaniu pri rovnakom stave
    if (prevAnalytics.current === hasAnalytics) return;
    prevAnalytics.current = hasAnalytics;

    if (hasAnalytics) {
      // Súhlas udelený – dynamicky nahráme GA4
      initGA();
    } else {
      // Súhlas odvolaný alebo nebol udelený – GA4 sa nespustí / zastaví
      revokeGA();
    }
  }, [consent]);

  return null;
}

export default AnalyticsLoader;
